import {initScriptForm} from "../../agents/voe-orders/scripts/initScriptForm";
import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";

function initPublicVoeOrderRequestIndex() {
	const voeScriptCard = document.querySelector('.voe-script-card');

	const sourceResponderFields = [
		// Source responder fields
		'source_responder_first_name',
		'source_responder_last_name',
		'source_responder_position',
		'source_responder_telephone',
		'source_responder_cellphone',
		'source_responder_work_email',
		'source_responder_personal_email',
		'source_responder_source_type'
	]

	const scriptFields = [
		// Standard script fields
		'voe_result_origin_key',
		'employer_division',
		'employment_status_key',
		'job_title',
		'most_recent_start_date',
		'most_recent_end_date',
		'original_start_date',
		'years_with_employer',
		'months_with_employer',
		'reason_for_leaving',
		'compensation',
		'other_information',
	];

	// Custom questions script fields
	const voeCustomQuestionsFields = window['custom_questions_fields_names'];

	initScriptForm(voeScriptCard);

	// Init Buttons
	voeScriptCard.querySelector('.save-progress-button')
		.addEventListener('click', handleSaveProgressRequest);

	voeScriptCard.querySelector('.submit-form-button')
		.addEventListener('click', handleSubmitRequest);


	/**
	 * Methods
	 */

	function handleSaveProgressRequest() {
		const sourceResponderData = getInputsByName(voeScriptCard, sourceResponderFields);
		const scriptData = getInputsByName(voeScriptCard, scriptFields);

		const data = {
			sourceResponderData,
			scriptData,
		}

		if (voeCustomQuestionsFields) {
			data.voeCustomQuestionsData = getInputsByName(voeScriptCard, voeCustomQuestionsFields);
		}

		clearFeedbacksByName(voeScriptCard);
		loading();

		Axios.post(window['routes/public.voe-orders.save-voe-request'], data)
			.then(response => {
				handleAjaxSuccess(response, () => {
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleSubmitRequest() {
		swalConfirm({
			title: 'Are you ready to submit this VOE?',
			text: "You won't be able to change your submission later"
		}).then(result => {
			if (result.isConfirmed) {
				const sourceResponderData = getInputsByName(voeScriptCard, sourceResponderFields);
				const scriptData = getInputsByName(voeScriptCard, scriptFields);

				const data = {
					sourceResponderData,
					scriptData,
				}

				if (voeCustomQuestionsFields) {
					data.voeCustomQuestionsData = getInputsByName(voeScriptCard, voeCustomQuestionsFields);
				}

				clearFeedbacksByName(voeScriptCard);
				loading();

				Axios.post(window['routes/public.voe-orders.submit-voe-request'], data)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

}

export {initPublicVoeOrderRequestIndex}
